/* eslint-disable import/first, import/newline-after-import */
import(/* webpackChunkName: "license-select", webpackPreload: true */ 'components/resources/show/resource-show-license-select/resource-show-license-select');
import(/* webpackChunkName: "license-info-modal", webpackPreload: true */ 'components/license/license-info-modal/license-info-modal');
import(/* webpackChunkName: "license-compare-modal", webpackPreload: true */ 'components/license/license-compare-modal/license-compare-modal');
import(/* webpackChunkName: "license-attribution-modal", webpackPreload: true */ 'components/license/license-attribution-modal/license-attribution-modal');
import(/* webpackChunkName: "copy-link", webpackPreload: true */ 'utils/copy_link_component/copy_link_component.css');

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import(/* webpackChunkName: "copy-link" */ 'utils/copy_link_component/copy-link-controller')
  .then((controller) => {
    EezyStimulusApplication.register('copy-link', controller.default);
  });

import(/* webpackChunkName: "license-compare-modal" */ 'components/license/license-compare-modal/license-compare-modal-controller')
  .then((controller) => {
    EezyStimulusApplication.register('license-compare-modal', controller.default);
  });
